<template>
<div class="roadContainer">
  <div :class="tilt"></div>
</div>
</template>

<script>
export default {
  name: 'ComponentRoadLines',
  props: {
    tilt: String,
  }, 
}   
</script>

<style lang="scss">

.roadContainer {
  width: 40%;
  z-index: -3;
}

.roadlines {
  position: absolute;
  width: 30px;
  height: 200px;
  background-color: transparent;
  /*transform: rotate(90deg);*/
  transform-origin: center;
  transform-style: preserve-3d;
  transform: perspective(100px) rotateX(30deg);
  bottom: 25%;
  right: 0;

  &.to-left-1 {
    left: 20px;
  }

  &.to-left-2 {
    left: 30px;
  }

  &.to-left-3 {
    left: 50px;
  }

  &.to-left-extreme {
    left: 80px;
  }

  &.to-right-1 {
    right: 10px;
  }

  &.to-right-2 {
    right: 20px;
  }
  
  &.to-right-3 {
    right: 50px;
  }

  &.to-right-extreme {
    right: 80px;
  }
}

.roadlines:before {
  content: "";
  position: absolute;
  left: 40%;
  top: 0;
  width: 10px;
  height: 100%;
  background-image: linear-gradient(
    0deg,
    yellow 0%,
    yellow 40%,
    transparent 40%,
    transparent 100%
  );
  background-size: 1px 100px;
  animation: animateroad 2s linear infinite;
}

@keyframes animateroad {
  0% {
    background-position-y: 0px;
  }
  100% {
    background-position-y: -100px;
  }
}

</style>